// currency should be by ISO 4217 three-letter code format

export enum Currency {
    USD = 'USD',
    GBP = 'GBP',
    EUR = 'EUR',
    AUD = 'AUD',
    HUF = 'HUF',
    AED = 'AED',
    ARS = 'ARS',
    BRL = 'BRL',
    CAD = 'CAD',
    CHF = 'CHF',
    CNY = 'CNY',
    CNH = 'CNH',
    CZK = 'CZK',
    DKK = 'DKK',
    HKD = 'HKD',
    INR = 'INR',
    JPY = 'JPY',
    KRW = 'KRW',
    MXN = 'MXN',
    NOK = 'NOK',
    PLN = 'PLN',
    RUB = 'RUB',
    SEK = 'SEK',
    SGD = 'SGD',
    TRY = 'TRY',
    ZAR = 'ZAR',
    RON = 'RON',
    PHP = 'PHP',
    NZD = 'NZD',
    THB = 'THB',
    VND = 'VND',
    MYR = 'MYR',
    IDR = 'IDR',
    BDT = 'BDT',
    FJD = 'FJD',
    KGS = 'KGS',
    KZT = 'KZT',
    LKR = 'LKR',
    NPR = 'NPR',
    PKR = 'PKR',
    ISK = 'ISK',
    ALL = 'ALL',
    AMD = 'AMD',
    AZN = 'AZN',
    BAM = 'BAM',
    GEL = 'GEL',
    RSD = 'RSD',
    ILS = 'ILS',
    QAR = 'QAR',
    SAR = 'SAR',
    AOA = 'AOA',
    BWP = 'BWP',
    DZD = 'DZD',
    EGP = 'EGP',
    GMD = 'GMD',
    KES = 'KES',
    LSL = 'LSL',
    MAD = 'MAD',
    MGA = 'MGA',
    MUR = 'MUR',
    MWK = 'MWK',
    NAD = 'NAD',
    NGN = 'NGN',
    RWF = 'RWF',
    SCR = 'SCR',
    TZS = 'TZS',
    XAF = 'XAF',
    XOF = 'XOF',
    ZMW = 'ZMW',
    BBD = 'BBD',
    BOB = 'BOB',
    BSD = 'BSD',
    BZD = 'BZD',
    CLP = 'CLP',
    COP = 'COP',
    CRC = 'CRC',
    DOP = 'DOP',
    GTQ = 'GTQ',
    GYD = 'GYD',
    HNL = 'HNL',
    JMD = 'JMD',
    NIO = 'NIO',
    PEN = 'PEN',
    PYG = 'PYG',
    TTD = 'TTD',
    UYU = 'UYU',
}

export enum StablecoinCurrency {
    USDC = 'USDC',
}

// List of supported currencies, ordered by priority works in Awx either Wise
export const buyerSupportedCurrencies = [
    Currency.USD,
    Currency.EUR,
    Currency.GBP,
    Currency.CAD,
    Currency.AUD,
    Currency.AED,
    Currency.SEK,
    Currency.SGD,
    Currency.HKD,
    Currency.DKK,
    Currency.PLN,
    Currency.NZD,
];

export const awxOnlySupportedCurrencies = [Currency.RON, Currency.MXN, Currency.JPY];

export function getCurrencyPriority(currency: Currency) {
    const priorityIndex = buyerSupportedCurrencies.findIndex((item) => item === currency);
    if (priorityIndex > -1) {
        return priorityIndex;
    }

    return buyerSupportedCurrencies.length + Object.keys(Currency).findIndex((item) => item === currency);
}

export function sortCurrenciesAlphabetically(currencies: Currency[], priorityCurrencies: Currency[]): Currency[] {
    const priority = currencies.filter((c) => priorityCurrencies.includes(c));
    const remaining = currencies.filter((c) => !priorityCurrencies.includes(c)).sort();
    return Array.from(new Set([...priority, ...remaining]));
}

export const invoiceCurrencies = [Currency.USD, Currency.EUR, Currency.GBP, Currency.AUD, Currency.CAD, Currency.CNY, Currency.HKD];

export const internationalWireOnlySupportedCurrencies = [Currency.SEK, Currency.RON, Currency.PLN];

export const domesticWireOnlySupportedCurrencies = [Currency.AUD, Currency.MXN, Currency.AED, Currency.NZD];
